import React, { useState, useEffect } from 'react';
import axios from '../utils/axiosWithAuth';

const SendNotification = () => {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [url, setUrl] = useState('/jobs');
  const [status, setStatus] = useState('');
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser?.email === 'aubair245@gmail.com') {
      setIsAllowed(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/push/send-notification`,
        {
          title: title || "📢 New Job Update!",
          message: message || "Check the latest job openings now.",
          url: url.startsWith("http")
            ? url
            : `${process.env.REACT_APP_FRONTEND_URL}${url.startsWith("/") ? url : `/${url}`}`
        }
      );

      setStatus(`✅ Notification sent to ${res.data.count || 1} subscribers!`);
    } catch (err) {
      console.error("❌ Notification send error:", err);
      setStatus(err.response?.data?.error || '❌ Failed to send notification');
    }
  };

  if (!isAllowed) {
    return (
      <div style={{ padding: '20px', color: 'crimson' }}>
        ⛔ You are not authorized to view this page.
      </div>
    );
  }

  return (
    <div style={{ padding: '30px', maxWidth: '600px', margin: '0 auto' }}>
      <h2 style={{ marginBottom: '20px' }}>📢 Send Push Notification</h2>

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div>
          <label><strong>Title:</strong></label>
          <input
            type="text"
            value={title}
            onChange={e => setTitle(e.target.value)}
            required
            style={{ width: '100%', padding: '10px' }}
          />
        </div>

        <div>
          <label><strong>Message:</strong></label>
          <input
            type="text"
            value={message}
            onChange={e => setMessage(e.target.value)}
            required
            style={{ width: '100%', padding: '10px' }}
          />
        </div>

        <div>
          <label><strong>URL (on click):</strong></label>
          <input
            type="text"
            value={url}
            onChange={e => setUrl(e.target.value)}
            style={{ width: '100%', padding: '10px' }}
          />
        </div>

        <button
          type="submit"
          style={{
            padding: '12px',
            backgroundColor: '#198754',
            color: 'white',
            fontWeight: 'bold',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          🚀 Send Notification
        </button>
      </form>

      {status && (
        <p
          style={{
            marginTop: '20px',
            fontWeight: 'bold',
            color: status.startsWith('✅') ? 'green' : 'red',
          }}
        >
          {status}
        </p>
      )}
    </div>
  );
};

export default SendNotification;
